import { api } from './client';

/** Moves whenever data is saved anywhere — polled so the dashboard reloads only on a change. */
export async function fetchDashboardVersion(): Promise<number> {
  return (await api.get<{ version: number }>('/health/dashboard/version')).data.version;
}
